import { OperationVariables } from '@apollo/client';
import { useQuery } from '@apollo/client/react';

export type LoadingStatus = 'idle' | 'loading' | 'loaded' | 'error';

export const getLoadingStatus = <T, U extends OperationVariables>(
  queryResult: useQuery.Result<T, U>
): LoadingStatus => {
  if (queryResult.error) return 'error';
  if (queryResult.data !== undefined) return 'loaded';
  return 'loading';
};

export const getLazyLoadingStatus = (queryResult: {
  error?: unknown;
  loading: boolean;
  data?: unknown;
}): LoadingStatus => {
  if (queryResult.error != null) return 'error';
  if (queryResult.loading) return 'loading';
  if (queryResult.data !== undefined) return 'loaded';
  return 'idle'; // Not yet fetched
};
